export const normalizeApiList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.countries)) return data.countries;
  if (Array.isArray(data?.states)) return data.states;
  if (Array.isArray(data?.districts)) return data.districts;
  if (Array.isArray(data?.cities)) return data.cities;
  return [];
};

export const mapGeoOptions = (items) => {
  const list = normalizeApiList(items);

  return list
    .map((item) => {
      const label =
        item.name ||
        item.country_name ||
        item.state_name ||
        item.district_name ||
        item.city_name ||
        item.tier ||
        item.value ||
        "";

      const value =
        item.country_id ??
        item.state_id ??
        item.district_id ??
        item.city_id ??
        item.tier_id ??
        item.id;

      return {
        label: String(label),
        value: String(value ?? ""),
        name: String(label),
        ...(item.tier_id != null ? { tier_id: String(item.tier_id) } : {}),
      };
    })
    .filter((option) => option.label && option.value);
};

export const findGeoOptionByName = (options, name) => {
  if (!name || !options?.length) return null;

  const normalized = name.trim().toLowerCase();
  return (
    options.find((option) => option.label.trim().toLowerCase() === normalized) ||
    null
  );
};

export const findDistrictForCityId = (districts, cityId) => {
  if (!cityId || !districts?.length) return null;

  const id = String(cityId);
  return (
    districts.find((option) => id === option.value) ||
    districts.find((option) => id.startsWith(option.value)) ||
    null
  );
};

export const getPincodeValidationError = (response) => {
  if (response?.valid === false || response?.is_valid === false) {
    return (
      response?.message ||
      response?.detail ||
      "Invalid pincode for selected city"
    );
  }

  return null;
};

export const extractApiErrorMessage = (error, fallback) => {
  if (typeof error?.data === "string") {
    return error.data;
  }

  return (
    error?.data?.detail ||
    error?.data?.message ||
    error?.message ||
    fallback
  );
};
